<script>
	import SvelteMarkdown from 'svelte-markdown';
	import snarkdown from 'snarkdown';

	export let content = {
		isLoaded: false,
		content: ''
	};
	let content_body = content.content;
</script>

{#if content.isLoaded}
	{@html snarkdown(content_body)}
	<SvelteMarkdown {content_body} />
{/if}